// extracted by mini-css-extract-plugin
export var active = "_e3-7";
export var container = "_e3-0";
export var evenWidth = "_e3-4";
export var large = "_e3-5";
export var outlet = "_e3-8";
export var slide = "_e3-2";
export var small = "_e3-6";
export var tab = "_e3-3";
export var tabs = "_e3-1";